<template>
  <main>
    <v-card v-if="loaded" style="border-radius: 10px">
      <v-card-title style="font-size: 1rem">
        How Did You Hear About Camp
      </v-card-title>
      <v-card-text>
        <PieChart :chartData="chartData" :options="options" />
      </v-card-text>
    </v-card>
    <v-col v-else cols="12" class="text-center">
      <v-progress-circular
        size="100"
        class="text-center"
        indeterminate
        color="primary"
      ></v-progress-circular>
    </v-col>
  </main>
</template>

<script>
import { IndexData } from "@/helpers/apiMethods";

export default {
  name: "HearingSource",
  components: {
    PieChart: () => import("@/components/PieChart")
  },
  data() {
    return {
      loaded: false,
      chartData: {
        labels: [],
        datasets: [
          {
            backgroundColor: [
              "#e2893f",
              "#cc7b38",
              "#f8ae81",
              "#b16a2f",
              "#fbd5c4",
              "#fac3a8",
              "#f69c52"
            ],
            data: [],
            borderColor: "#fff"
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: false,
        pieceLabel: {
          mode: "percentage",
          precision: 1
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              return (
                data["labels"][tooltipItem["index"]] +
                ": " +
                Math.ceil(data["datasets"][0]["data"][tooltipItem["index"]]) +
                "%"
              );
            }
          }
        },
        plugins: {
          datalabels: {
            labels: {
              title: {
                font: {
                  weight: "bold"
                }
              },

              value: {
                color: "green"
              }
            },

            color: "white",
            textAlign: "center",
            font: {
              weight: "bold",
              size: 14
            },
            formatter: (value, ctx) => {
              let sum = 0;
              let percentage;
              let dataArr = ctx.chart.data.datasets[0].data;
              dataArr.map((data, index) => {
                sum += data;
                if (value > 10) {
                  percentage =
                    Math.ceil((value * 100) / sum) +
                    "%" +
                    " " +
                    ctx.chart.data.labels[ctx.dataIndex];
                }
              });

              return percentage;
            }
          }
        }
      }
    };
  },

  methods: {
    handleGetData(query) {
      this.loaded = false;
      IndexData({
        reqName: "/dashboard/hearing-source-statistics",
        query
      }).then(res => {
        const { data } = res.data;
        this.chartData.labels = data.map(el => el.name);
        this.chartData.datasets[0].data = data.map(el => el.percentage);
        this.loaded = true;
      });
    }
  },
  watch: {
    $route: {
      handler({ query }) {
        this.handleGetData(query);
      },
      immediate: true
    }
  }
};
</script>
